import React, { useEffect, useState } from "react";
import tick from "../../assets/images/tick.png";
import cross from "../../assets/images/cross.png";
import EntryCard from "./entry-card";
import scan from "../../assets/images/scan.png";
import mannual from "../../assets/images/manual.png";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../../pages/preview/Drawing.module.scss";
import { Upload } from "@progress/kendo-react-upload";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { toast } from "react-toastify";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import axios from "axios";
import useModelStore from "../../store/model-store";
import useOrderStore from "../../store/order-store";
import { useRouter } from "../../pages/routes/hooks/use-router";
const LFOrder = ({ nextStep, leadDetail, isMobile }) => {
  const { modelData, setModelData, resetModel } = useModelStore();

  const [uploadGutterSheet, setUploadGutterSheet] = useState(false);
  const { orderData, setFormData: setOrderFormData } = useOrderStore();

  const [selectedType, setSelectedType] = useState(null);
  useEffect(() => {
    setUploadGutterSheet(modelData.isOrderSheet);
    setSelectedType(modelData.orderSheetUploadType);
  }, [modelData]);
  const navigate = useNavigate();
  const { id } = useParams();
  const [crop, setCrop] = useState();
  const [cropLoading, setCropLoading] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState(null);
  const [isUsed, setIsUsed] = useState(false);
  const [image, setImage] = useState(null);
  const [output, setOutput] = useState(null);
  const [file, setFile] = useState(null);
  const router = useRouter();

  const arr1 = [
    {
      image: scan,
      title: "Scan",
      path: ``,
    },
    {
      image: mannual,
      title: "Manual",
      path: `/scan-preview/${id}?hasSheet=false&leadId=${leadDetail?.leadId}`,
    },
  ];
  const arr1Click = (name) => {
    setSelectedType(name);
    setModelData({ ...modelData, orderSheetUploadType: name });
    if (name == "Manual") {
      navigate(
        `/scan-preview/${id}?hasSheet=false&leadId=${leadDetail?.leadId}`
      );
    }
  };

  const handleAdd = (event) => {
    setOutput(null);
    setFile(null);
    setSrc(null);
    setIsUsed(false);
    const newFiles = event.affectedFiles.map((fileWrapper) =>
      fileWrapper.getRawFile()
    );
    selectImage(newFiles[0]);
    setFile(newFiles[0]);
  };

  const handleRemove = (event) => {
    setFile(null);
    setImgSrc(null);
    setSrc(null);
    setIsUsed(false);
    setOutput(null);
  };
  const selectImage = (file) => {
    if (file) {
      setOutput(URL.createObjectURL(file));
      setSrc(URL.createObjectURL(file));
    }
  };
  function base64ToFile(base64String, filename, mimeType) {
    // Decode the base64 string
    const byteString = atob(base64String.split(",")[1]);

    // Create an array of 8-bit unsigned integers
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the byteArray
    const file = new File([byteArray], "myImage", { type: "image/png" });

    return file;
  }

  const handleSubmittoApi2 = async (selectedFile) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);
    try {
      const response = await axios.post(
        `https://scanapi.mhalt.com/upload/order-sheet`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const sizes = response.data.data?.lower_analysis?.SizeGridDetails;
      const measurements = response?.data?.data.upper_analysis;
      const data = response.data?.data?.full_analysis;
      let profile = Object.keys(data?.LeafFilterProfile).filter(
        (key) => data?.LeafFilterProfile[key]
      );
      profile = profile.map((item) =>
        item === "VersaMax" ? "Versa Max" : item
      );

      let newMeasurements = Object.keys(
        measurements?.Dimensions.Columns["1st"]
      ).map((key) => ({
        label:
          key === "RAndRRTotal"
            ? "R & RR Total"
            : key.replace(/([A-Z])/g, " $1").trim(),
        firstStory: [
          measurements?.Dimensions.Columns["1st"][key].Box1 || "",
          measurements?.Dimensions.Columns["1st"][key].Box2 || "",
        ],
        secondStory: [
          measurements?.Dimensions.Columns["2st"][key]?.Box1 || "",
          measurements?.Dimensions.Columns["2st"][key]?.Box2 || "",
        ],
        thirdStory: [
          measurements?.Dimensions.Columns["3rd"][key]?.Box1 || "",
          measurements?.Dimensions.Columns["3rd"][key]?.Box2 || "",
        ],
      }));

      const totalValues = {
        firstStory: [0, 0], // total for [0] and [1] indices
        secondStory: [0, 0],
        thirdStory: [0, 0],
      };
      ["firstStory", "secondStory", "thirdStory"].forEach((story) => {
        [0, 1].forEach((idx) => {
          const totalForIndex = newMeasurements.reduce(
            (total, measurement, i) => {
              if (i < newMeasurements.length - 2) {
                // Exclude the "Total" measurement
                total += parseFloat(measurement[story][idx]) || 0; // Handle NaN if value is empty
              }
              return total;
            },
            0
          );
          totalValues[story][idx] = totalForIndex; // Store total for each index (0 and 1)
        });
      });
      // Update the "Total" section with the new calculated totals for all stories and indices
      newMeasurements[newMeasurements.length - 2].firstStory[0] =
        totalValues.firstStory[0].toString() || 0;
      newMeasurements[newMeasurements.length - 2].secondStory[0] =
        totalValues.secondStory[0].toString() || 0;
      newMeasurements[newMeasurements.length - 2].thirdStory[0] =
        totalValues.thirdStory[0].toString() || 0;

      // Store the totals for the second index (index 1) for each story as well
      newMeasurements[newMeasurements.length - 2].firstStory[1] =
        totalValues.firstStory[1].toString() || 0;
      newMeasurements[newMeasurements.length - 2].secondStory[1] =
        totalValues.secondStory[1].toString() || 0;
      newMeasurements[newMeasurements.length - 2].thirdStory[1] =
        totalValues.thirdStory[1].toString() || 0;
      const grandTotal = Object.values(totalValues).reduce(
        (storySum, storyTotals) => {
          return (
            storySum +
            storyTotals.reduce(
              (indexSum, indexTotal) => indexSum + indexTotal,
              0
            )
          );
        },
        0
      );

      const orderValues = {
        customer: data?.CustomerDetails.Customer,
        city: data?.CustomerDetails.City,
        state: data?.CustomerDetails.State,
        job: data?.CustomerDetails.JobNumber,
        gutterProfile:
          Object.keys(data?.GutterProfile).filter(
            (key) => data?.GutterProfile[key]
          )[0] || "K-Style",
        leafFilterProfile: profile,
        versa_max_quantity: data?.GutterDetails?.VersaMaxQuantity?.Value,
        measurements: newMeasurements,
        color: data?.LeafFilterColor.ColorOptions || "White",
        leafFilterColor: data?.LeafFilterColor.ModularAndVersaColor,
        existingGutterColor: data?.LeafFilterColor.ExistingGutterColor,
        gutterOpeningWidth:
          data?.GutterDetails?.GutterOpeningWidth?.CircleOption,
        gutterOpeningWidthValue:
          data?.GutterDetails?.GutterOpeningWidth?.CustomWidth,
        totalFootage: grandTotal,
        partial: data?.GutterDetails.TotalFootage.Partial,
        csr: data?.GutterDetails.CleanSealRainforce.CircleOption === "Clean",
        csr_value: data?.GutterDetails.CleanSealRainforce.Footage || "",
        insideCorners: data?.GutterDetails.InsideCorners,
        outsideCorners: data?.GutterDetails.OutsideCorners,
        existingProtection: data?.GutterDetails.ExistingProtection.Required,
        existingProtectionType:
          data?.GutterDetails.ExistingProtection.Type || "Screen",
        mountingType: data?.GutterDetails.FastenerTypes.CircleOption,
        mountMethod: "",
        mountingLength: data?.GutterDetails.FastenerTypes.Footage || 0,
        roof: data?.GutterDetails.SpringClipsRequired.Required,
        roofColor: data?.GutterDetails.SpringClipsRequired.Color,
        roofType: data?.GutterDetails.RoofTypes.CircleOption,
        roofTypeValue:
          data?.GutterDetails.RoofTypes.CircleOption == "Other"
            ? data?.GutterDetails.RoofTypes.RoofTypeValue
            : "",
        extensionsNeeded: data?.AdditionalDetails.ExtensionsNeeded
          ? "Yes"
          : "No",
        extensionFootage: data?.AdditionalDetails.Footage,
        groundSpoutNeeded: data?.AdditionalDetails.GroundspoulNeeded
          ? "Yes"
          : "No",
        units: data?.AdditionalDetails.Units,
        sizes: Object.entries(sizes).map(([key, values]) => ({
          label: key.replace(")", ""),
          values: [
            values["2x3"] || null,
            values["3x4"] || null,
            values["Round 3"] || null,
            values["Round 4"] || null,
          ],
        })),
        AElbows: data?.AdditionalDetails.Elbows.NumberAElbows,
        BElbows: data?.AdditionalDetails.Elbows.NumberBElbows,
        spoutSaverQuantity: data?.AdditionalDetails.SpoutsaverQuantity || "",
        ladders: data?.AdditionalDetails.Ladders.CircleOption,
        laddersValue: data?.AdditionalDetails.Ladders.LadderValue,
        walkboards: data?.AdditionalDetails.WalkBoards ? "Yes" : "No",
        obstruction: data?.AdditionalDetails.Obstructions,
        note: data?.Notes,
        files: [],
        hasSheet: false,
      };
      setLoading(false);
      setOrderFormData(orderValues);
      router.push(
        `/scan-preview/${id}?hasSheet=false&leadId=${leadDetail.leadId}`
      );
    } catch (error) {
      setLoading(false);
      toast.error(
        "Your choosen image is not recognized by the system please select different image"
      );
    }
  };

  const cropImageNow = () => {
    setCropLoading(true);
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    // Adjust canvas size for high resolution
    const pixelRatio = window.devicePixelRatio;
    const qualityMultiplier = 5;
    let effectiveRatio = pixelRatio * qualityMultiplier;

    canvas.width = crop.width * effectiveRatio;
    canvas.height = crop.height * effectiveRatio;

    const ctx = canvas.getContext("2d");

    // Set transformation for high-quality scaling
    ctx.setTransform(effectiveRatio, 0, 0, effectiveRatio, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    // Draw the cropped image
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    // Export to PNG
    let base64Image = canvas.toDataURL("image/png");
    let imageSizeKB = base64Image.length / 1024;

    // Downscale if size exceeds 4MB
    while (imageSizeKB > 4000 && effectiveRatio > 1) {
      effectiveRatio *= 0.9; // Reduce the ratio by 10%
      canvas.width = crop.width * effectiveRatio;
      canvas.height = crop.height * effectiveRatio;

      ctx.setTransform(effectiveRatio, 0, 0, effectiveRatio, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      base64Image = canvas.toDataURL("image/png");
      imageSizeKB = base64Image.length / 1024;
    }

    if (imageSizeKB <= 4000) {
      setOutput(base64Image);
      setCropLoading(false);
      setIsUsed(true);
    } else {
      setCropLoading(false);
      console.error("Failed to generate an image under 4MB.");
    }
  };
  return (
    <>
      <div
        style={{ paddingTop: "10px" }}
        className={isMobile ? "" : "k-scrollable"}
      >
         
     {leadDetail.mhalt ?
     <div style={{marginBottom:isMobile ? "50px" : ''}}>

     {leadDetail.orderSheet ? <h2 className="k-font-normal k-mt-4">
     The lf order sheet has been successfully uploaded. <a
    href={`/scan-preview/${leadDetail?._id}?hasSheet=true&leadId=${leadDetail?.leadId}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{ cursor: "pointer", fontWeight: "bold",textDecoration:"none",listStyle:"none",color:"black" }}
  >
    Click here to view it.
  </a>
         </h2> : <h2>You don't have a lf order sheet uploaded.</h2>}
    </div>
    :
     <>
        {leadDetail?.orderSheetDraft ? (
          <div className="">
            <h2 className="k-font-normal k-mt-4">
              You have a LF Order Sheet saved as a draft. Please submit it or
              make any necessary edits.
            </h2>
            <div
              className={`k-display-flex k-justify-content-end k-mt-8 ${
                !isMobile && "k-mb-2"
              } k-fixed-footer`}
            >
              <Button
                type="button"
                className="k-mr-2 k-button-red2"
                size={isMobile ? "small" : "large"}
                onClick={() => setModelData({ ...modelData, open: false })}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  router.push(
                    `/scan-preview/${leadDetail?._id}?hasSheet=false&leadId=${leadDetail?.leadId}`
                  );
                }}
                type="button"
                className="k-mr-2 k-button-green"
                size={isMobile ? "small" : "large"}
              >
                Edit Draft
              </Button>
            </div>
          </div>
        ) : !uploadGutterSheet ? (
          <div className="k-text-center">
            <h2 className="k-font-normal k-mt-4">
              Does this job require Leaf Filter Sheet?
            </h2>
            <div
              className={`k-display-flex k-md-gap-less k-justify-content-center k-gap-20 k-mt-10 k-px-8`}
            >
              <div
                onClick={() => {
                  nextStep();
                  setModelData({ ...modelData, isOrderSheet: false });
                }}
                className="k-text-center"
              >
                <div
                  className={`${isMobile ? 'k-py-4 k-px-10' : 'k-py-8 k-px-16'}  k-elevation-1 k-rounded-lg k-cursor-pointer`}
                  style={{ color: "#FFFFFF" }}
                >
                  <img height={64} width={64} alt="img" src={cross} />
                </div>
                <h2 className="k-font-bold k-mt-5 k-sm-sub-heading">No</h2>
              </div>

              <div
                onClick={() => {
                  setModelData({ ...modelData, isOrderSheet: true });
                  setUploadGutterSheet(true);
                }}
                className="k-text-center"
              >
                <div
                  className={`${isMobile ? 'k-py-4 k-px-10' : 'k-py-8 k-px-16'}  k-elevation-1 k-rounded-lg k-cursor-pointer`}
                  style={{ color: "#FFFFFF" }}
                >
                  <img height={64} width={64} alt="img" src={tick} />
                </div>
                <h2 className="k-font-bold k-mt-5 k-sm-sub-heading">Yes</h2>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="k-text-center">
              <h1 className="k-font-semibold k-sm-heading">
                {selectedType != "Scan"
                  ? "Choose Entry Method"
                  : file
                  ? "Crop Image"
                  : "Choose Image"}
              </h1>
              <h4 className="k-font-normal k-mt-4">
                {selectedType != "Scan"
                  ? "Select an option to proceed with your document submission"
                  : file
                  ? "Please ensure that the image you upload contains only the paper and no other objects or backgrounds"
                  : `Please upload the Gutter Sheet Image`}
              </h4>
            </div>
            {selectedType != "Scan" && (
              <div
                className={`k-display-flex k-md-gap-less k-justify-content-center k-gap-20 k-mt-10 k-px-8`}
              >
                {arr1.map((item) => (
                  <EntryCard
                    handleClick={arr1Click}
                    handleOpen={() => {}}
                    item={item}
                  />
                ))}
              </div>
            )}
            {selectedType == "Scan" && (
              <>
                <div
                  className={`k-display-flex k-gap-5 ${styles.uploaderContainer}`}
                  style={{ width: "100%" }}
                >
                  <Upload
                    accept="image/*"
                    batch={false}
                    multiple={false}
                    defaultFiles={[]}
                    withCredentials={false}
                    saveUrl={
                      "https://demos.telerik.com/kendo-ui/service-v4/upload/save"
                    }
                    removeUrl={
                      "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
                    }
                    onAdd={handleAdd}
                    onRemove={handleRemove}
                  />
                </div>
                {file && (
                  <div
                    className={`k-display-flex k-md-flex-column k-md-gap-less k-justify-content-center k-gap-20 k-mt-2`}
                  >
                    <div>
                      <div className="k-display-flex k-justify-content-between">
                        <h2 className="k-m-0 k-pb-2">Image</h2>
                        <div className="">
                          <Button
                            type="button"
                            className="k-button-green k-mb-2"
                            size="large"
                            disabled={cropLoading}
                            style={{ width: "100px" }}
                            primary={true}
                            onClick={cropImageNow}
                          >
                            {cropLoading ? "Croping" : "Crop"}
                          </Button>
                        </div>
                      </div>
                      {src && (
                        <ReactCrop
                          src={src}
                          onImageLoaded={setImage}
                          crop={crop}
                          onChange={setCrop}
                        />
                      )}
                    </div>

                    <div>
                      <h2 className="k-m-0 k-pb-2 k-mb-3">Result</h2>
                      <div>
                        {output && (
                          <img
                            className="myCanvusandImage2"
                            height={500}
                            src={output}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
        </>}
  
      </div>
      {selectedType == "Scan" && !leadDetail.orderSheet && !leadDetail.orderSheetDraft &&  (
        <div className="k-display-flex k-justify-content-end k-mt-8 k-mb-2">
          <Button
            disabled={loading}
            style={{ width: "100px" }}
            primary={true}
            className="k-button-red2 k-mr-2"
            size="large"
            type="button"
            onClick={() => {
              setSelectedType(null);
              setIsUsed(false);
              setFile(null);
              setImgSrc(null);
            }}
          >
            Back
          </Button>
          <Button
            type="button"
            style={{ width: "100px" }}
            primary={true}
            onClick={() => {
              if (isUsed) {
                const myfile = base64ToFile(output);
                if (!myfile) {
                  return toast.error("Please Choose The Image");
                } else {
                  handleSubmittoApi2(myfile);
                }
              } else {
                if (!file) {
                  return toast.error("Please Choose The Image");
                } else {
                  handleSubmittoApi2(file);
                }
              }
            }}
            disabled={loading}
            className="k-button-green k-mr-2"
            size="large"
          >
            {loading ? (
              <>
                <Loader
                  size="small"
                  type="converging-spinner"
                  style={{ color: "white" }}
                />{" "}
                Scaning
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      )}
    </>
  );
};

export default LFOrder;
